import { render, staticRenderFns } from "./TrainingCertification.vue?vue&type=template&id=1bd8362f&scoped=true&"
import script from "./TrainingCertification.vue?vue&type=script&lang=js&"
export * from "./TrainingCertification.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCertification.vue?vue&type=style&index=0&id=1bd8362f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd8362f",
  null
  
)

export default component.exports